import { render } from "./SectionTwo.vue?vue&type=template&id=5c2533ba&scoped=true"
import script from "./SectionTwo.vue?vue&type=script&lang=js"
export * from "./SectionTwo.vue?vue&type=script&lang=js"

import "./SectionTwo.vue?vue&type=style&index=0&id=5c2533ba&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\PLATEFORME-AUTO-PREFEREPLUS\\paprep-spa\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c2533ba"]])

export default __exports__